
import { DatePicker } from "@/components/ui/date-picker";

interface DateSelectorProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
}

export const DateSelector = ({ selectedDate, onDateChange }: DateSelectorProps) => {
  return (
    <div className="mb-4">
      <label htmlFor="date" className="block text-sm font-medium mb-1">
        Fecha de asistencia:
      </label>
      <DatePicker
        id="date"
        value={selectedDate}
        onChange={onDateChange}
        maxYear={new Date().getFullYear() + 1} // Permitir fechas hasta un año en el futuro
        className="w-full"
      />
    </div>
  );
};
